var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDesktopApp)?_c('desktop-app-header'):_vm._e(),(!_vm.isDesktopApp && !_vm.reactNativeApp && !_vm.noSecurity)?_c('security-popup'):_vm._e(),_c('ddos-popup'),(_vm.restrictUser)?_c('restrict-user'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }